module.exports = __webpack_public_path__ + "img/noKnowledge.e3a97ef3.png";